export const TARIFF_SECTOR_DROPDOWN = [
  {
    label: "billingOnboarding.industry",
    value: "Industry",
  },
  {
    label: "billingOnboarding.publicAndPrivateServices",
    value: "Public",
  },
] as const;
